<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <div class="row">
      <div class="col-sm-6">
        <span class="titlePage">{{ titlePage }}</span>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsInstrucoes"
          :status="status"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actions"
          addFilter
          :items="listarPublicacoes"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editInstrucao"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="editarPublicacao.inscatID === 0 ? addInstrucao() : editarInstrucao()"
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-12">
            <label>Selecione a categoria</label>
            <v-select
              :options="listandoCategorias"
              v-model="categorias"
              class="selectSPI"
              label="inscatDescricao"
              placeholder="Selecione a Categoria"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!categorias"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="editarPublicacao.insID" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="editarPublicacao.insAssunto" required
              >Assunto</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <vue-editor v-model="editarPublicacao.insDescricao" />
          </div>
        </div>
        <div class="row innerPage" v-if="editarPublicacao.inscatID === 0">
          <div class="col-sm-12">
            <label>Insira Rotas</label>
            <v-select
              :options="listarRotas"
              multiple
              v-model="newRotas"
              class="selectSPI"
              label="objNome"
              placeholder="Rotas"
            >
              <template v-slot:option="option">
                {{ option.objNome }} - {{ option.objLink }}
              </template>
            </v-select>
          </div>
        </div>
        <div class="row innerPage" v-else>
          <div class="col-sm-12">
            <label>Insira Rotas</label>
            <v-select
              :options="listarRotas"
              v-model="newRotas"
              class="selectSPI"
              label="objNome"
              placeholder="Rotas"
              @input="addRota(newRotas)"
            >
              <template v-slot:option="option">
                {{ option.objNome }} - {{ option.objLink }}
              </template>
            </v-select>
          </div>
        </div>
        <div class="row innerPage" v-if="rotas.length > 0">
          <div class="col-sm-12">
            <b-table striped hover :items="rotas" :fields="fieldsRotas">
              <template v-slot:cell(actions)="item">
                <button
                  type="button"
                  @click="deleteRota(item.item)"
                  class="buttonTransparente"
                  v-b-tooltip.hover
                  title="Excluir Rota"
                >
                  <font-awesome-icon icon="trash" size="lg" />
                </button>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <label>Ativo</label><br />
            <toggle-button v-model="editarPublicacao.insAtivo" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Instruções',
      titleModal: '',
      titlePDF: 'Instruções',
      listarPublicacoes: [],
      listandoCategorias: [],
      baseUrlInstrucao: '',
      categorias: {},
      listarRotas: {},
      rotas: {},
      newRotas: '',
      editarPublicacao: {},
      itemPorPage: '100',
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'insAtivo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsInstrucoes: [
        { key: 'insID', label: 'ID', sortable: true, active: true },
        { key: 'inscatDescricao', label: 'Categoria', sortable: true, active: true },
        { key: 'insAssunto', label: 'Assunto', sortable: true, active: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      fieldsRotas: [
        { key: 'insRotId', label: 'ID', sortable: true },
        { key: 'insRotLink', label: 'Rotas', sortable: true },
        { key: 'actions', label: '', sortable: false }
      ]
    }
  },
  methods: {
    listandoPublicacoes: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlInstrucao + 'Instrucao/ListarTodasInstrucao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          var lista = response.data
          delete lista['insDescricao']
          if (lista.length > 0) {
            for (var values of Object.values(lista)) {
              delete values.insDescricao
            }
          }
          this.listarPublicacoes = lista
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarCategorias: function () {
      axios
        .get(this.baseUrlInstrucao + 'Categoria/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listandoCategorias = response.data
        })
        .catch(this.setErrorSystem)
    },
    addField: function () {
      this.titleModal = 'Adicionar Instrução'
      this.editarPublicacao = {}
      this.editarPublicacao.insAtivo = true
      this.editarPublicacao.insDescricao = 'Texto'
      this.rotas = 0
      this.categorias = ''
      this.newRotas = ''
      this.editarPublicacao.inscatID = 0
      this.$root.$emit('bv::show::modal', 'editInstrucao')
    },
    changeStatus: function (action, item) {
      axios
        .get(
          this.baseUrlInstrucao + 'Instrucao/ListarPorId' + item.insID,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          var status = item.insAtivo
          this.editarPublicacao = response.data
          this.editarPublicacao.insAtivo = status
          this.editarInstrucao('changeStatus')
        })
        .catch((e) => {
          this.setErrorSystem(e)
        })
    },
    editField: function (action, item) {
      axios
        .get(
          this.baseUrlInstrucao + 'Instrucao/ListarPorId' + item.insID,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.rotas = {}
          this.editarPublicacao = response.data
          this.categorias = {
            inscatID: item.inscatID,
            inscatDescricao: item.inscatDescricao
          }
          this.rotas = item.listaInstrucaoRotas
          this.titleModal = 'Editar Instrução'
          this.$root.$emit('bv::show::modal', 'editInstrucao')
        })
        .catch(this.setErrorSystem)
    },
    addInstrucao: function () {
      if (this.newRotas.length > 0) {
        var listaInstrucaoRotas = []
        for (var listaPublicacao of Object.values(this.newRotas)) {
          listaInstrucaoRotas.push({
            insRotId: 0,
            insID: 0,
            insRotLink: listaPublicacao.objLink,
            objID: listaPublicacao.objID
          })
        }
        var enviarRota = {
          insID: 0,
          inscatID: this.categorias.inscatID,
          insCodigo: this.editarPublicacao.insAssunto,
          insAssunto: this.editarPublicacao.insAssunto,
          insDescricao: this.editarPublicacao.insDescricao,
          insAtivo: this.editarPublicacao.insAtivo,
          inscatDescricao: this.categorias.inscatDescricao,
          listaInstrucaoRotas
        }
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlInstrucao + 'Instrucao/AdicionarInstrucao',
            enviarRota,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoPublicacoes()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.adicionado, 'success')
            this.$root.$emit('bv::hide::modal', 'editInstrucao')
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert('Erro', 'Preencha os Campos', 'error', 'error')
      }
    },
    editarInstrucao: function (status = 'ok') {
      if (status === 'ok') {
        this.editarPublicacao.inscatID = this.categorias.inscatID
        this.editarPublicacao.inscatDescricao = this.categorias.inscatDescricao
      }
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .post(
          this.baseUrlInstrucao + 'Instrucao/AlterarInstrucao',
          this.editarPublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoPublicacoes()
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editInstrucao')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoRotas: function () {
      axios
        .get(
          this.baseUrlInstrucao + 'InstrucaoRota/ListarRota',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          var lista = response.data
          lista.forEach((element) => {
            if (element.objLink === '/' || element.objLink === '' || element.objLink === ' ') {
              lista = this.arrayRemove(lista, element)
            }
          })
          this.listarRotas = lista
        })
        .catch(this.setErrorSystem)
    },
    addRota: function (item) {
      var rota = {
        insRotId: 0,
        insID: this.editarPublicacao.insID,
        insRotLink: item.objLink,
        objID: item.objID
      }
      var verifica = this.rotas.find((rotas) => rotas.insRotLink === rota.insRotLink)
      if (verifica === undefined) {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlInstrucao + 'InstrucaoRota/AdicionarRota',
            rota,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            rota.insRotId = response.data
            this.rotas.push(rota)
            this.listandoPublicacoes()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.editado, 'success')
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert('Error', 'Rota já adicionada a essa instrução', 'error')
      }
    },
    deleteRota: function (item) {
      this.callConfirm(this.mensagemExcluir, item.insRotLink).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlInstrucao + 'InstrucaoRota/ExcluirRota/' + item.insRotId,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoPublicacoes()
              var removeRota = this.arrayRemove(this.rotas, item)
              this.rotas = removeRota
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.insAssunto).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlInstrucao + 'Instrucao/ExcluirInstrucao/' + item.insID,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoPublicacoes()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlInstrucao = this.$fccStore.state.baseUrlInstrucao
    this.listarCategorias()
    this.listandoPublicacoes()
    this.listandoRotas()
  }
}
</script>
